module.exports = __webpack_public_path__ + "static/media/watch2.ba4cf1a8.jpg";